/**
 * Carrusel en celular para las listas marcadas con [data-oj-carrusel] (y la clase .oj-carrusel-movil,
 * que hace el desplazamiento con CSS). Agrega puntos de avance que marcan la tarjeta visible y, solo
 * mientras la lista se desliza de lado, la vuelve enfocable para moverla con las flechas del teclado.
 * En pantallas anchas la lista vuelve a ser rejilla y los puntos se ocultan.
 */
const MOVIL = window.matchMedia('(max-width: 749px)');

/**
 * @param {HTMLElement} lista
 */
function preparar(lista) {
  if (lista.dataset.ojCarruselListo) return;
  const elementos = [...lista.children].filter((hijo) => hijo instanceof HTMLElement);
  if (elementos.length < 2) return;
  lista.dataset.ojCarruselListo = 'true';

  const puntos = document.createElement('div');
  puntos.className = 'oj-carrusel-puntos';
  puntos.setAttribute('aria-hidden', 'true');
  for (let i = 0; i < elementos.length; i += 1) puntos.append(document.createElement('span'));
  lista.after(puntos);

  /** @param {number} indice */
  const marcar = (indice) => {
    [...puntos.children].forEach((punto, i) => punto.toggleAttribute('data-activo', i === indice));
  };
  marcar(0);

  const observador = new IntersectionObserver(
    (entradas) => {
      if (!MOVIL.matches) return;
      // La tarjeta que solo asoma también «intersecta»: cuenta la que se ve en su mayoría.
      for (const entrada of entradas) {
        if (entrada.intersectionRatio >= 0.55) marcar(elementos.indexOf(/** @type {HTMLElement} */ (entrada.target)));
      }
    },
    { root: lista, threshold: 0.6 }
  );
  for (const elemento of elementos) observador.observe(elemento);

  const ajustar = () => {
    if (MOVIL.matches) {
      lista.tabIndex = 0;
      lista.setAttribute('aria-label', lista.dataset.ojCarrusel || 'Desliza para ver más');
    } else {
      lista.removeAttribute('tabindex');
      lista.removeAttribute('aria-label');
    }
  };
  ajustar();
  MOVIL.addEventListener('change', ajustar);

  const limpiar = () => {
    observador.disconnect();
    MOVIL.removeEventListener('change', ajustar);
  };
  lista.addEventListener('oj:carrusel-limpiar', limpiar, { once: true });
}

/**
 * @param {ParentNode} raiz
 */
function iniciar(raiz) {
  for (const lista of raiz.querySelectorAll('[data-oj-carrusel]')) {
    if (lista instanceof HTMLElement) preparar(lista);
  }
}

iniciar(document);

// Editor de temas: al recargar o quitar una sección se vuelve a preparar o se limpia.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) iniciar(event.target);
});
document.addEventListener('shopify:section:unload', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  for (const lista of event.target.querySelectorAll('[data-oj-carrusel]')) {
    lista.dispatchEvent(new CustomEvent('oj:carrusel-limpiar'));
  }
});
